import { gql } from "@apollo/client";

export const GET_ALL_EQUIPMENT_WITH_FULL_DETAIL = gql`
    query {
        allEquipment {
            id

            sku
            category {
                id
                name
            }
            quantity
            name
            description
            itemWeightInLbs

            createdBy {
                id
            }
            lastUpdatedBy {
                id
            }
        }
    }
`

export const GET_ALL_EQUIPMENT_FOR_SELECT_FIELD = gql`
    query allEquipment {
        allEquipment {
            id
            name
            category {
                name
            }
            sku
            quantity
        }
    }
`

export const GET_ALL_EQUIPMENT_FOR_SELECT_FIELD_WITHOUT_QUANTITY = gql`
    query allEquipment {
        allEquipment {
            id
            name
            category {
                name
            }
            sku
            itemWeightInLbs
            quantity
        }
    }
`

export const GET_EQUIPMENT_BY_ID_WITH_FULL_DETAIL = gql`
    query equipment($id: Int!) {
        equipment(id: $id) {
            id

            sku
            category {
                id
                name
            }
            quantity
            name
            description
            itemWeightInLbs

            createdBy {
                id
            }
            lastUpdatedBy {
                id
            }
        }
    }
`

export const GET_EQUIPMENT_BY_ID_FOR_EDIT_FORM = gql`
    query equipment($id: Int!) {
        equipment(id: $id) {
            id
            sku
            category {
                name
                id
            }
            name
            description
            itemWeightInLbs
        }
    }
`

export const GET_EQUIPMENT_BY_CATEGORY = gql`
    query equipmentByCategory($category: String!) {
        equipmentByCategory(category: $category) {
            id
            sku
            name
            description
            quantity
        }
    }
`

export const GET_EQUIPMENT_BY_ID_WITH_NAME = gql`
    query equipment($id: Int!) {
        equipment(id: $id) {

            name
            
        }
    }
`

export const GET_EQUIPMENT_BY_ID_WITH_QUANTITY = gql`
    query equipment($id: Int!) {
        equipment(id: $id) {

            quantity
            
        }
    }
`

export const GET_EQUIPMENT_BY_ID_WITH_SPECIFICATIONS = gql`
    query equipment($id: Int!) {
        equipment(id: $id) {

            category {
                id
                name
            }
            sku
            itemWeightInLbs
            
        }
    }
`

export const GET_EQUIPMENT_BY_ID_WITH_DESCRIPTION = gql`
    query equipment($id: Int!) {
        equipment(id: $id) {

            description
            
        }
    }
`

export const GET_EQUIPMENT_BY_ID_WITH_LOGS = gql`
    query equipment($id: Int!) {
        equipment(id: $id) {

            shippingLogs {
                id
                dateAndTime
                quantity

                toJob {
                    name
                }

                createdBy {
                    firstName
                    lastName
                }
            }

            adjustmentLogs {
                id

                dateAndTime
                quantity
                reason

                createdBy {
                    firstName
                    lastName
                }
            }

            receivingLogs {
                id
                dateAndTime
                quantity

                fromJob {
                    name
                }
                fromPurchaseOrder {
                    number
                }

                createdBy {
                    firstName
                    lastName
                }
            }
            
            cycleCountLogs {
                id
                dateCounted
                expectedQuantity
                countedQuantity

                createdBy {
                    firstName
                    lastName
                }
            }
        }
    }
`

export const GET_EQUIPMENT_FOR_CYCLE_COUNTS = gql`
    query equipmentForCycleCounts {
        equipmentForCycleCounts {
            id
            name
            quantity
            category {
                id
            }
        }
    }
`